import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd/lib/grid';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './style.scss';
import { Props } from './typing';
import InputField from '../../../../../../components/TextInput';
import ProfileFooter from '../ProfileFooter';
import {
  ifscCodeValidationRegex,
  alphabetValidationRegex,
  numberValidationRegex,
} from '../../../../../../lib/constants';
import {
  getIfscAction,
  getSignzyTokenAction,
  getBankVerifyAction,
} from '../../../../../../redux/actions/completeProfile';
import {
  decryptUsingAES256,
  encryptUsingAES256,
  getMerchantDetailsFromStore,
} from '../../../../../../lib/helper';
import Button from '../../../../../../components/Button';
import notify from '../../../../../../lib/notifiy';
import SelectDropdown from '../../../../../../components/Select';
import { noIFSCList, AccountType } from './constants';
import imgURL from 'lib/imgURL';

const BankDetails: FC<Props> = (props): JSX.Element => {
  const { entityType, merchantName, leadId } = getMerchantDetailsFromStore();
  const {
    nextPage,
    prevPage,
    currentStep,
    setCurrentStep,
    merchantProfile,
    updateProfileDetails,
    validationErrors,
    getIfscAction,
    ifscState,
    signzyAuthState,
    getSignzyTokenAction,
    // getBankVerifyAction,
    bankVerifyState,
  } = props;

  const [bankDetails, setBankDetails]: any = useState({});
  const [merchantDetails, setMerchantDetails]: any = useState({});
  const [bankInfo, setBankInfo]: any = useState({});
  const [enableVerify, setEnableVerify] = useState(false);
  const [, setSignzyAuth] = useState({});

  const formik = useFormik({
    initialValues: {
      Remitter1AccountType: bankDetails?.Remitter1AccountType || '',
      Remitter1BankAccountNumber: bankDetails?.Remitter1BankAccountNumber || '',
      Remitter1BankAccountName: bankDetails?.Remitter1BankAccountName || '',
      Remitter1BeneficiaryName: bankDetails?.Remitter1BeneficiaryName || '',
      Remitter1IFSCcode: bankDetails?.Remitter1IFSCcode || '',
      Remitter2AccountType: bankDetails?.Remitter2AccountType || '',
      Remitter2BankAccountNumber: bankDetails?.Remitter2BankAccountNumber || '',
      Remitter2BankAccountName: bankDetails?.Remitter2BankAccountName || '',
      Remitter2BeneficiaryName: bankDetails?.Remitter2BeneficiaryName || '',
      Remitter2IFSCcode: bankDetails?.Remitter2IFSCcode || '',
      BankName: bankDetails?.BankName || '',
      AccountType: AccountType,
      BeneficiaryName:
        bankDetails?.BeneficiaryName ||
        merchantDetails?.LegalName,
      AccountNo: bankDetails?.AccountNo || '',
      ConfirmAccountNo: bankDetails?.ConfirmAccountNo || '',
      IFSC: bankDetails?.IFSC || '',
    },
    validationSchema: Yup.object({
      BankName: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      AccountType: Yup.string()
        .matches(numberValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      BeneficiaryName: Yup.string()
        .matches(alphabetValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      AccountNo: Yup.string()
        .matches(numberValidationRegex, validationErrors.REQUIRED_FIELD)
        .trim(),
      ConfirmAccountNo: Yup.string().when('AccountNo', {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref('AccountNo')],
          validationErrors.ACCOUNT_NUMBER_MISMATCH
        ),
      }),
      IFSC: Yup.string()
        .trim()
        .matches(ifscCodeValidationRegex, validationErrors.INVALID_IFSC_CODE),
    }),
    onSubmit: () => {},
  });

  useEffect(() => {
    if (merchantProfile?.bankDetails !== '') {
      try {
        setBankDetails(
          JSON.parse(decryptUsingAES256(merchantProfile?.bankDetails, leadId))
        );
      } catch (e) {
        // Catch Error
      }
    }
  }, [merchantProfile?.bankDetails]);

  useEffect(() => {
    if (merchantProfile?.merchantDetails !== '') {
      try {
        setMerchantDetails(
          JSON.parse(decryptUsingAES256(merchantProfile?.merchantDetails, leadId))
        );
      } catch (e) {
        // Catch Error
      }
    }
  }, [merchantProfile?.merchantDetails]);

  useEffect(() => {
    if (bankDetails) {
      formik.setValues({
        ...formik.values,
        Remitter1AccountType: bankDetails?.Remitter1AccountType || '',
        Remitter1BankAccountNumber:
          bankDetails?.Remitter1BankAccountNumber || '',
        Remitter1BankAccountName: bankDetails?.Remitter1BankAccountName || '',
        Remitter1BeneficiaryName: bankDetails?.Remitter1BeneficiaryName || '',
        Remitter1IFSCcode: bankDetails?.Remitter1IFSCcode || '',
        Remitter2AccountType: bankDetails?.Remitter2AccountType || '',
        Remitter2BankAccountNumber:
          bankDetails?.Remitter2BankAccountNumber || '',
        Remitter2BankAccountName: bankDetails?.Remitter2BankAccountName || '',
        Remitter2BeneficiaryName: bankDetails?.Remitter2BeneficiaryName || '',
        Remitter2IFSCcode: bankDetails?.Remitter2IFSCcode || '',
        BankName: bankDetails?.BankName || '',
        AccountType: AccountType,
        BeneficiaryName:
          bankDetails?.BeneficiaryName ||
          merchantDetails?.LegalName,
        AccountNo: bankDetails?.AccountNo || '',
        ConfirmAccountNo: bankDetails?.ConfirmAccountNo || '',
        IFSC: bankDetails?.IFSC || '',
      });
    }
  }, [bankDetails, merchantDetails]);

  const callFormSubmit = (step, statusData) => {
    // if (statusData.completed && !bankDetails.isBankVerified) {
    //   notify({
    //     message: 'Bank Verification Needed',
    //     type: 'error',
    //     description:
    //       'Please Click the "Verify" Button to validate the Bank details.',
    //   });
    //   return false;
    // } else {
    const merchantProfileValue = {
      ...merchantProfile,
      bankDetails: encryptUsingAES256(
        JSON.stringify({
          ...formik.values,
          isBankVerified: !!bankDetails?.isBankVerified,
        }),
        leadId
      ),
    };
    updateProfileDetails(step, statusData, merchantProfileValue);
    // }
  };

  const enableSave = () => {
    return (
      Object.keys(formik.values).filter((key) => {
        return formik.values[key] !== '';
      }).length > 0
    );
  };

  const enableSaveAndNext = () => {
    return (
      formik.values.BeneficiaryName !== '' &&
      formik.values.AccountNo !== '' &&
      formik.values.ConfirmAccountNo !== '' &&
      formik.values.IFSC !== '' &&
      !(
        formik.errors.BeneficiaryName ||
        formik.errors.AccountNo ||
        formik.errors.ConfirmAccountNo ||
        formik.errors.IFSC
      )
    );
  };

  const pennyDropVerify = () => {
    // const panVerifyPayload = {
    //   task: 'bankTransferLite',
    //   essentials: {
    //     beneficiaryAccount: formik.values.AccountNo,
    //     beneficiaryIFSC: formik.values.IFSC,
    //     beneficiaryName: formik.values.BeneficiaryName,
    //     nameFuzzy: 'true',
    //   },
    // };
    // getBankVerifyAction(panVerifyPayload, signzyAuth);
  };

  useEffect(() => {
    const { isSuccess, isFailure, data } = bankVerifyState;
    if (isSuccess) {
      if (!data?.result?.active || data?.result?.active !== 'yes') {
        formik.setFieldError('AccountNo', 'Account Number is not active');
      } else if (
        !data?.result?.nameMatch ||
        data?.result?.nameMatch !== 'yes'
      ) {
        formik.setErrors({
          BeneficiaryName:
            'Beneficiary Name is not matching for the given Account Number ',
        });
      } else if (!data?.result?.reason || data?.result?.reason !== 'success') {
        formik.setErrors({
          AccountNo:
            'Bank details could not be verified . Please re-try after sometime .',
        });
      }

      if (
        data?.result?.active === 'yes' &&
        data?.result?.nameMatch === 'yes' &&
        data?.result?.reason === 'success'
      ) {
        notify({
          message: 'Success',
          type: 'success',
          description: 'Bank Details Verification Successfull',
        });
        const merchantProfileValue = {
          ...merchantProfile,
          bankDetails: encryptUsingAES256(
            JSON.stringify({
              ...formik.values,
              isBankVerified: true,
            }),
            leadId
          ),
        };
        updateProfileDetails(
          currentStep,
          {
            saved: true,
            completed: false,
          },
          merchantProfileValue
        );
      }
    }

    if (isFailure) {
      formik.setFieldError(
        'AccountNo',
        'Bank details could not be verified . Please re-try after sometime .'
      );
    }
  }, [bankVerifyState]);

  useEffect(() => {
    const { isSuccess, isFailure, data } = signzyAuthState;
    if (isSuccess && data) {
      setSignzyAuth({ ...data });
    }

    if (isFailure) {
      setSignzyAuth({});
    }
  }, [signzyAuthState]);

  useEffect(() => {
    if (
      formik.values.AccountNo !== '' &&
      formik.values.IFSC !== '' &&
      formik.values.BeneficiaryName !== ''
    ) {
      setEnableVerify(true);
    } else {
      setEnableVerify(false);
    }
  }, [
    formik.values.AccountNo,
    formik.values.IFSC,
    formik.values.BeneficiaryName,
  ]);

  useEffect(() => {
    const { isSuccess, isFailure, data } = ifscState;
    if (isSuccess && data.apiName) {
      setBankInfo(data);
      formik.setFieldValue('BankName', data.apiName);
    } else {
      setBankInfo({ errorMessage: 'No Bank Details avialable.' });
      formik.setFieldValue('BankName', '');
    }
    if (isFailure) {
      setBankInfo({ errorMessage: 'No Bank Details avialable.' });
      formik.setFieldValue('BankName', '');
    }
  }, [ifscState]);

  useEffect(() => {
    getSignzyTokenAction();
  }, []);

  useEffect(() => {
    if (
      formik?.values?.IFSC !== '' &&
      ifscCodeValidationRegex.test(formik.values.IFSC)
    ) {
      getIfscAction(formik.values.IFSC);
    } else {
      setBankInfo({ errorMessage: 'No Bank Details avialable.' });
      formik.setFieldValue('BankName', '');
    }
  }, [formik.values.IFSC]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='kyc-bank-details'>
        <Row>
          <Col span={6}>
            <div className='title'>Bank Details</div>
          </Col>
        </Row>

        <div className='plural-bank-details'>
          {bankDetails.isBankVerified && (
            <Row className='success-header'>
              <Col className='ben-name-info' span={13}>
                <div className='bank-verify'>
                  <img width={28} src={imgURL['success-icon']} alt='sucess' />
                  <label className='success-msg'>
                    Bank Details verified Successfully.
                  </label>
                </div>
              </Col>
            </Row>
          )}
          <Row>
            <Col span={6}>
              <InputField
                name='BeneficiaryName'
                type='text'
                label='Settlement Bank Beneficiary Name'
                isRequired={true}
                value={
                  entityType === '8'
                    ? merchantName
                    : formik.values.BeneficiaryName
                }
                placeholder='Settlement Bank Beneficiary Name'
                className='form-control'
                handleChange={formik.handleChange}
                readonly={entityType !== '8' || bankDetails.isBankVerified}
                error={Boolean(formik.errors.BeneficiaryName)}
                errorMessage={formik.errors.BeneficiaryName?.toString()}
              />
            </Col>
            <Col span={6} offset={1} className='ben-name-info'>
              <div>
                The bank account holder name should match your legal name. Your
                account application may be rejected if you fail to provide a
                bank account matching this criteria.
              </div>
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <InputField
                name='AccountNo'
                type='text'
                label='Bank Account No'
                isRequired={true}
                value={formik.values.AccountNo}
                placeholder='Bank Account Number'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={bankDetails.isBankVerified}
                error={Boolean(formik.errors.AccountNo)}
                errorMessage={formik.errors.AccountNo?.toString()}
              />
            </Col>
            <Col span={6} offset={1}>
              <InputField
                name='ConfirmAccountNo'
                type='text'
                label='Confirm Bank Account No'
                isRequired={true}
                value={formik.values.ConfirmAccountNo}
                placeholder='Confirm Bank Account Number'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={bankDetails.isBankVerified}
                error={Boolean(formik.errors.ConfirmAccountNo)}
                errorMessage={formik.errors.ConfirmAccountNo?.toString()}
              />
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <InputField
                name='IFSC'
                type='text'
                label='IFSC Code'
                isRequired={true}
                value={formik.values.IFSC}
                placeholder='Enter IFSC Code'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={bankDetails.isBankVerified}
                error={Boolean(formik.errors.IFSC)}
                errorMessage={formik.errors.IFSC?.toString()}
              />
            </Col>
            <Col span={6} offset={1} className='ben-name-info'>
              {!bankInfo.bank ? (
                <div className={`form-group`}>
                  <label>
                    Bank Name<em>*</em>
                  </label>
                  <SelectDropdown
                    enableSearch={true}
                    wrapperClass='form-control'
                    value={formik.values.BankName}
                    onChange={(value) => {
                      formik.setFieldValue('BankName', value);
                    }}
                    optionList={Object.keys(noIFSCList).map((item) => ({
                      value: item,
                      label: noIFSCList[item],
                    }))}
                    error={Boolean(
                      formik.touched.BankName && formik.errors.BankName
                    )}
                    errorMessage={formik.errors.BankName?.toString()}
                  />
                </div>
              ) : (
                <div className='ifsc-bank-name'>
                  {`${bankInfo.bank} - ${bankInfo.branch} - ${bankInfo.address}`}
                </div>
              )}
            </Col>
            {!bankDetails.isBankVerified && (
              <Col className='ben-name-info' span={3} offset={1}>
                <div className='bank-verify'>
                  <Button
                    btnStyleClass='login-primary-button'
                    onClick={pennyDropVerify}
                    label={'Verify'}
                    enable={enableVerify}
                    type='button'
                  />
                </div>
              </Col>
            )}
          </Row>

          <div className='divider' />
        </div>
      </div>
      <ProfileFooter
        nextPage={nextPage}
        prevPage={prevPage}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        saveAction={callFormSubmit}
        enableSave={enableSave()}
        enableSaveAndNext={enableSaveAndNext()}
        // blockNext={bankDetails?.isBankVerified}
      />
    </form>
  );
};

const mapStateToProps = ({ validationReducer, completeProfileReducer }) => ({
  validationErrors: validationReducer.validationErrorState.validationErrors,
  signzyAuthState: completeProfileReducer?.signzyAuthState,
  ifscState: completeProfileReducer?.ifscState,
  bankVerifyState: completeProfileReducer?.bankVerifyState,
});

export default connect(mapStateToProps, {
  getIfscAction,
  getSignzyTokenAction,
  getBankVerifyAction,
})(BankDetails);
